import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Home from "./Pages/Home/Home";
import Admin from "./Pages/Admin/Admin";
import './global.css'
import {ADMIN_PATH} from "./config";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path={ADMIN_PATH} element={<Admin/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
